<template>
  <el-dialog
    :title="
      dialogConfig.type == '0'
        ? '新增入库'
        : dialogConfig.type == '1'
        ? '编辑入库'
        : '入库详情'
    "
    v-model="visible"
    width="60%"
    style="overflow: hidden"
    :close-on-click-modal="false"
  >
    <el-collapse
      v-model="activeNames"
      style="overflow-y: auto; height: 55vh"
      v-loading="loading"
    >
      <el-collapse-item title="入库信息" name="baseMsg">
        <el-form
          :model="formData"
          label-width="100px"
          ref="ruleRef"
          :rules="rules"
          v-if="dialogConfig.type == '0' || dialogConfig.type == '1'"
        >
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="入库单号：" prop="number">
                <el-input
                  v-model="formData.number"
                  placeholder="自动生成"
                  :maxlength="40"
                  v-no-space
                  :disabled="true"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="入库类型：" prop="type">
                <el-select
                  v-model="formData.type"
                  placeholder="请选择"
                  style="width: 100%"
                  @change="changeType"
                >
                  <el-option
                    v-for="item in typeList"
                    :key="item.id"
                    :label="item.dictLabel"
                    :value="String(item.dictValue)"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="warehouseId" label-width="120px">
                <template #label>
                  <span
                    >入库仓库：<el-tooltip
                      placement="top"
                      content="切换仓库即清空所选物料列表"
                      ><el-icon><QuestionFilled /></el-icon></el-tooltip
                  ></span>
                </template>
                <el-select
                  v-model="formData.warehouseId"
                  placeholder="请选择"
                  style="width: 100%"
                  @change="warehouseChanged"
                >
                  <el-option
                    v-for="item in stashList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="入库时间：" prop="boundTime">
                <el-date-picker
                  type="datetime"
                  v-model="formData.boundTime"
                  style="width: 100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  placeholder="请选择入库时间"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="入库人：" prop="boundUser">
                <el-select
                  v-model="formData.boundUser"
                  filterable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in userList"
                    :key="item.id"
                    :label="item.nikeName"
                    :value="item.userCode"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="供应商：" prop="supplier">
                <el-input
                  v-model="formData.supplierName"
                  placeholder="请输入"
                  @click="handleSupplierChange"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                label="送货人电话："
                prop="deliveryPhone"
                label-width="auto"
              >
                <el-input
                  v-model="formData.deliveryPhone"
                  placeholder="请输入"
                  :maxlength="40"
                  v-no-space
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="车牌号码：" prop="carNumber">
                <el-input
                  v-model="formData.carNumber"
                  placeholder="请输入"
                  :maxlength="40"
                  v-no-space
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="送货单位：" prop="deliveryDepartment">
                <el-input
                  v-model="formData.deliveryDepartment"
                  placeholder="请输入"
                  :maxlength="40"
                  v-no-space
                />
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row :gutter="10">
            <el-col :span="8" v-if="formData.type == 3">
              <el-form-item label="工程名称" prop="thirdResourceName">
                <el-input
                  v-model="formData.thirdResourceName"
                  placeholder="请输入"
                  :maxlength="40"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="formData.type == 3">
              <el-form-item label="工程编号" prop="thirdResourceRef">
                <el-input
                  v-model="formData.thirdResourceRef"
                  placeholder="请输入"
                  :maxlength="40"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="formData.type == 2">
              <el-form-item label="厂站名称" prop="thirdResourceId">
                <el-tree-select
                  v-model="formData.thirdResourceId"
                  :data="factoryStationList"
                  node-key="id"
                  :props="defaultProps"
                  :expand-on-click-node="false"
                  @node-click="handleNodeClick"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="工程类型" prop="projectType">
                <el-select
                  v-model="formData.projectType"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in projectList"
                    :key="item.id"
                    :label="item.dictLabel"
                    :value="String(item.dictValue)"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col>
              <el-form-item label="备注：" prop="remark">
                <el-input
                  type="textarea"
                  v-model="formData.remark"
                  :rows="3"
                  :maxlength="200"
                  show-word-limit
                  placeholder="请输入"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-descriptions border :column="3" v-else>
          <el-descriptions-item
            label="工程名称"
            span="1"
            width="16%"
            v-if="formData.type == 3"
          >
            <span class="my_class">{{
              formData.thirdResourceName ? formData.thirdResourceName : "-"
            }}</span>
          </el-descriptions-item>
          <el-descriptions-item
            label="厂站名称"
            span="1"
            width="16%"
            v-if="formData.type == 2"
          >
            <span class="my_class">{{
              formData.authOrganizationalDTO
                ? formData.authOrganizationalDTO.organizationName
                : "-"
            }}</span>
          </el-descriptions-item>
          <el-descriptions-item
            label="工程编号"
            span="1"
            width="16%"
            v-if="formData.type == 3"
          >
            <span class="my_class">{{
              formData.thirdResourceRef ? formData.thirdResourceRef : "-"
            }}</span>
          </el-descriptions-item>
          <el-descriptions-item
            v-for="item in descriptionList"
            :key="item.value"
            :label="item.label"
            :span="item.span || 1"
            width="16%"
          >
            <span class="my_class">{{
              formData[item.value]
            }}</span></el-descriptions-item
          >
        </el-descriptions>
      </el-collapse-item>
      <el-collapse-item title="物料信息" name="materiel">
        <div class="flex">
          <el-text type="primary"></el-text>
          <el-button
            type="primary"
            @click="handleMaterielSelect()"
            v-if="dialogConfig.type == '0' || dialogConfig.type == '1'"
            >选择物料</el-button
          >
        </div>
        <el-table
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          class="mt10"
          :data="tableData"
        >
          <el-table-column label="序号" type="index" width="60" fixed />
          <template v-for="item in columns" :key="item.prop">
            <el-table-column
              :label="item.label"
              :prop="item.prop"
              :min-width="120"
              show-overflow-tooltip
            >
              <template #default="{ row, $index }">
                <!-- <el-input-number
                  v-if="
                    item.prop == 'price' &&
                    (dialogConfig.type == '0' || dialogConfig.type == '1')
                  "
                  v-model="row[item.prop]"
                  :controls="false"
                  style="width: 100%"
                  :min="0"
                  :precision="10"
                  :max="999999999"
                /> -->
                <span
                  v-if="
                    item.prop == 'price' &&
                    (dialogConfig.type == '0' || dialogConfig.type == '1')
                  "
                  >{{ row.price }}</span
                >
                <span
                  v-else-if="item.prop == 'price' && dialogConfig.type == '2'"
                  >{{ row.price }}</span
                >
                <span
                  v-else-if="
                    item.prop == 'totalWarehousePrice' &&
                    dialogConfig.type == '2'
                  "
                  >{{ row.totalWarehousePrice }}</span
                >
                <el-input
                  v-else-if="
                    item.prop == 'totalWarehousePrice' &&
                    (dialogConfig.type == '0' || dialogConfig.type == '1')
                  "
                  v-model="row[item.prop]"
                  :min="0"
                  :precision="10"
                  :max="999999999"
                >
                </el-input>
                <el-input-number
                  v-if="
                    item.prop == 'changeQuantity' &&
                    (dialogConfig.type == '0' || dialogConfig.type == '1')
                  "
                  v-model="row[item.prop]"
                  :controls="false"
                  style="width: 100%"
                  :min="0"
                  :precision="4"
                  :max="999999999"
                />
                <el-input
                  v-if="
                    item.prop == 'remark' &&
                    (dialogConfig.type == '0' || dialogConfig.type == '1')
                  "
                  v-model="row[item.prop]"
                  style="width: 100%"
                />
                <span
                  v-else-if="item.prop == 'remark' && dialogConfig.type == '2'"
                  >{{ row[item.prop] }}</span
                >
              </template>
            </el-table-column>
          </template>
          <el-table-column
            label="操作"
            fixed="right"
            v-if="dialogConfig.type == '0' || dialogConfig.type == '1'"
          >
            <template #default="{ $index }">
              <el-button type="primary" link @click="handleRemove($index)"
                >移除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-collapse-item>
      <el-collapse-item title="附件" name="files">
        <div class="flex">
          <el-text type="primary"></el-text>
          <el-button
            type="primary"
            @click="handleFileUpload()"
            v-if="dialogConfig.type == '0' || dialogConfig.type == '1'"
            >上传附件</el-button
          >
        </div>
        <el-table
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          class="mt10"
          :data="tableFileData"
        >
          <el-table-column label="序号" type="index" width="60" fixed />
          <template v-for="item in fileColumns" :key="item.prop">
            <el-table-column
              :label="item.label"
              :prop="item.prop"
              :min-width="120"
              show-overflow-tooltip
            >
            </el-table-column>
          </template>
          <el-table-column label="操作" fixed="right">
            <template #default="{ row, $index }">
              <el-button
                type="primary"
                link
                @click="handleRemoveFiles($index)"
                v-if="dialogConfig.type == '0' || dialogConfig.type == '1'"
                >移除</el-button
              >
              <el-button
                type="primary"
                link
                @click="fileDownload(row)"
                v-if="dialogConfig.type == '2'"
                >下载</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-collapse-item>
    </el-collapse>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleCancel()">返回</el-button>
        <el-button
          v-if="dialogConfig.type == '0' || dialogConfig.type == '1'"
          type="primary"
          @click="handleSubmit()"
          :disabled="buttonLoading"
        >
          保存
        </el-button>
      </span>
    </template>

    <!-- 物料选择组件 -->
    <MaterielSelection
      ref="selectRef"
      type="in"
      @selectDone="materielSelectDone"
    />
    <!-- 供应商选择组件 -->
    <SupplierSelection
      ref="supplierSelectRef"
      type="in"
      @selectDone="supplierSelectionDone"
    />
    <!-- 工程选择组件 -->
    <ProjectSelection
      ref="projectSelectRef"
      type="in"
      @selectDone="ProjectSelectionDone"
    />
    <!-- 文件导入 -->
    <InStorageFileUpload
      ref="uploadRef"
      @afterUpload="afterUpload"
      :fn="uploadExcelData"
      :uploadConfig="uploadConfig"
    />
  </el-dialog>
</template>

<script setup>
import { ElMessage } from "element-plus";
import { reactive, ref, watch } from "vue";
import MaterielSelection from "@/components/MaterielSelection.vue";
import SupplierSelection from "@/components/SupplierSelection.vue";
import ProjectSelection from "@/components/ProjectSelection.vue";
import useStashList from "../../hooks/useStashList";
import {
  insertBoundIn,
  queryDetailById,
  editBoundApi,
  getFactoryStationList,
} from "@/api/bound";
import { DICT_KEY } from "@/constants/dict";
import { queryDictList } from "@/api/dict";
import { queryStashById } from "@/api/stash";
import { querySupplierList } from "@/api/supplier";
import { base64ToFile } from "@/utils";
import { uploadFile } from "@/api/file";
import axios from "axios";
import ImageUpload from "@/components/ImageUpload.vue";
import InStorageFileUpload from "@/components/InStorageFileUpload.vue";
import useUserList from "../../hooks/useUserList";
import { postDownload } from "@/utils";
// 事件绑定
const emits = defineEmits(["afterSave"]);

// 仓库列表
const { stashList } = useStashList();

// 用户列表
const { userList } = useUserList();

// 入库类型列表
const typeList = ref([]);

// 当前选中的仓库的库位
const locationList = ref([]);

// 供应商列表
const supplierList = ref([]);

// 弹窗控制器
const visible = ref(false);

// 遮罩
const loading = ref(false);

// 表单ref
const ruleRef = ref(null);

// 物料选择ref
const selectRef = ref(null);

//供应商选择ref
const supplierSelectRef = ref(null);

// 项目选择ref
const projectSelectRef = ref(null);

// 保存按钮loading
const buttonLoading = ref(false);

// 弹窗打开接收参数
const dialogConfig = ref({});

// 文件列表
const fileList = ref("");

// 物料列表
const tableData = ref([]);

//文件列表
const tableFileData = ref([]);

// collapse组件默认展开子级
const activeNames = ref(["baseMsg", "materiel", "sign", "files"]);

// 文件上传ref
const uploadRef = ref(null);

// 供应商选中
const selectIndex = ref(null);

//厂站数据
const factoryStationList = ref([
  // {
  //   id: 1,
  //   label: "一级 1",
  //   children: [
  //     {
  //       id: 4,
  //       label: "二级 1-1",
  //       children: [
  //         {
  //           id: 9,
  //           label: "三级 1-1-1",
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   id: 2,
  //   label: "一级 2",
  //   children: [
  //     {
  //       id: 5,
  //       label: "二级 2-1",
  //     },
  //     {
  //       id: 6,
  //       label: "二级 2-2",
  //     },
  //   ],
  // },
  // {
  //   id: 3,
  //   label: "一级 3",
  //   children: [
  //     {
  //       id: 7,
  //       label: "二级 3-1",
  //     },
  //     {
  //       id: 8,
  //       label: "二级 3-2",
  //     },
  //   ],
  // },
]);

//厂站树
const defaultProps = {
  children: "children",
  label: "organizationName",
};

// 表单数据
const formData = ref({
  number: null,
  type: null,
  warehouseId: null,
  boundTime: null,
  boundUser: null,
  remark: null,
  files: [],
  carNumber: null,
  deliveryPhone: null,
  supplier: null,
  supplierName: null,
  deliveryDepartment: null,
  thirdResourceId: null,
  thirdResourceType: null,
  boundUserName: null,
  thirdResourceRef: null,
  typeText: null,
  authOrganizationalDTO: null,
  projectType: null,
});

// 描述列表
const descriptionList = ref([
  {
    label: "入库单号",
    value: "number",
  },
  {
    label: "入库类型",
    value: "typeText",
  },
  {
    label: "入库仓库",
    value: "warehouseName",
  },
  {
    label: "入库时间",
    value: "boundTime",
  },
  {
    label: "入库人",
    value: "boundUserName",
  },
  {
    label: "供应商",
    value: "supplierName",
  },
  {
    label: "备注",
    value: "remark",
    span: 3,
  },
]);

// 表单校验规则
const rules = reactive({
  // number: [
  //   { required: true, message: "请输入入库单号", trigger: "blur" },
  //   {
  //     pattern: /^[a-zA-Z0-9]+$/,
  //     message: "只能输入英文和数字",
  //     trigger: "blur",
  //   },
  // ],
  type: [{ required: true, message: "请选择入库类型", trigger: "change" }],
  warehouseId: [
    { required: true, message: "请选择入库仓库", trigger: "change" },
  ],
  boundUser: [{ required: true, message: "请选择入库人", trigger: "change" }],
  boundTime: [{ required: true, message: "请选择入库时间", trigger: "blur" }],
  supplier: [{ required: true, message: "请输入供应商", trigger: "blur" }],
  deliveryPhone: [
    { required: true, message: "请输入送货人电话", trigger: "blur" },
  ],
  deliveryDepartment: [
    { required: true, message: "请输入送货单位", trigger: "blur" },
  ],
  // thirdResourceName: [
  //   { required: true, message: "请输入工程名称", trigger: "change" },
  // ],
  thirdResourceId: [
    { required: true, message: "请选择工程或项目", trigger: "blur" },
  ],
});

// 表格列配置
const columns = ref([
  {
    label: "物料名称",
    prop: "materialName",
  },
  {
    label: "物料编号",
    prop: "number",
  },
  {
    label: "品牌",
    prop: "brand",
  },
  {
    label: "规格型号",
    prop: "model",
  },
  {
    label: "单位",
    prop: "unit",
  },
  // {
  //   label: "供应商",
  //   prop: "supplierName",
  // },
  {
    label: "入库单价（元）",
    prop: "price",
  },
  {
    label: "入库数量",
    prop: "changeQuantity",
  },
  {
    label: "入库总价",
    prop: "totalWarehousePrice",
  },
  {
    label: "备注",
    prop: "remark",
  },
]);

// 表格列配置
const fileColumns = ref([
  {
    label: "附件名称",
    prop: "name",
  },
  {
    label: "上传人",
    prop: "createByText",
  },
  {
    label: "上传时间",
    prop: "createTime",
  },
]);

// 弹窗打开
const handleDialogOpen = (config) => {
  dialogConfig.value = config;
  formData.value = {
    number: null,
    type: null,
    warehouseId: null,
    boundTime: null,
    boundUser: null,
    remark: null,
    files: [],
    carNumber: null,
    deliveryPhone: null,
    supplier: null,
    deliveryDepartment: null,
    thirdResourceId: null,
    thirdResourceType: null,
    boundUserName: null,
    warehouseName: null,
    id: null,
    thirdResourceRef: null,
    thirdResourceName: null,
    typeText: null,
    authOrganizationalDTO: null,
    supplierName: null,
    projectType: null,
  };
  ruleRef.value?.resetFields();
  tableData.value = [];
  tableFileData.value = [];
  if (config.type != "0") {
    getDetail(config.row.id);
  }
  getFactoryStation();
  getTypeList();
  getProjectList();
  getSupplierList();
  buttonLoading.value = false;
  visible.value = true;
};

// 根据id查询详情
const getDetail = (id) => {
  loading.value = true;
  queryDetailById(id)
    .then((res) => {
      // const keys = [
      //   "id",
      //   "boundTime",
      //   "boundUser",
      //   "boundUserName",
      //   "number",
      //   "remark",
      //   "type",
      //   "warehouseId",
      //   "warehouseName",
      //   "annex",
      // ];
      // formData.value.forEach((key) => {
      //   formData.value[key] = res.data[key];
      // });
      for (const key in formData.value) {
        formData.value[key] = res.data[key];
      }
      tableData.value = res.data.materialList;
      tableFileData.value = res.data.boundFileDTOList || [];
    })
    .finally(() => {
      previewImg(formData.value.annex, fileList);
      loading.value = false;
    });
};

//获取厂站
const getFactoryStation = () => {
  getFactoryStationList().then((res) => {
    factoryStationList.value = res.data;
  });
};

//文件上传
const handleFileUpload = () => {
  uploadRef.value?.handleDialogOpen();
};

//文件列表
const afterUpload = (result) => {
  console.log("刷新列表", result);
  result.forEach((item) => {
    item.name = item.originalName;
  });
  result.forEach((item) => {
    tableFileData.value.push(item);
  });
};

//点击选择厂站
const handleNodeClick = (val) => {
  formData.value.thirdResourceId = val.id;
  formData.value.thirdResourceType = "STATION";
};

// 點擊保存
const handleSubmit = () => {
  // let fileList = [];
  // console.log(tableFileData.value, "filelist");
  // if (tableFileData.value.length > 0) {
  //   tableFileData.value.forEach((item) => {
  //     let obj = {
  //       reduceUrl: item.reduceUrl,
  //       name: item.originalName || item.name,
  //     };
  //     fileList.push(obj);
  //   });
  // }
  //新增
  if (dialogConfig.value.type == 0) {
    buttonLoading.value = true;
    ruleRef.value?.validate((valid) => {
      if (valid) {
        try {
          const validateRes = formValidate();
          if (!validateRes) return (buttonLoading.value = false);
          const materialReqs = [...tableData.value];
          materialReqs.map((i) => {
            i.id = null;
          });
          let reqBody = {
            ...formData.value,
            id: null,
            materialReqs,
            boundType: "1",
            boundFileReqs: tableFileData.value,
          };
          addBound(reqBody);
        } catch (e) {
          console.log(e);
        }
      } else {
        buttonLoading.value = false;
      }
    });
  }
  //编辑
  else if (dialogConfig.value.type == 1) {
    buttonLoading.value = true;
    ruleRef.value?.validate((valid) => {
      if (valid) {
        try {
          const validateRes = formValidate();
          if (!validateRes) return (buttonLoading.value = false);
          const materialReqs = [...tableData.value];

          let reqBody = {
            ...formData.value,
            materialReqs,
            boundType: "1",
            boundFileReqs: tableFileData.value,
          };
          editBound(reqBody);
        } catch (e) {
          console.log(e);
        }
      } else {
        buttonLoading.value = false;
      }
    });
  }
};

// 表单提交前校验
const formValidate = () => {
  // 判断是否有选择物料
  if (tableData.value.length == 0) {
    ElMessage.error("未选择任何物料");
    return false;
  }

  // 判断物料列表中的库位和数量是否填充完毕
  const arr = tableData.value.filter((item) => {
    return item.price && item.changeQuantity && item.totalWarehousePrice;
  });

  if (arr.length == 0) {
    ElMessage.error("入库总价、入库单价和数量是必填项");
    return false;
  }

  return true;
};

// 点击取消
const handleCancel = () => {
  ruleRef.value?.resetFields();
  visible.value = false;
};

// 表格移除
const handleRemove = (index) => {
  tableData.value.splice(index, 1);
};

// 附件移除
const handleRemoveFiles = (index) => {
  tableFileData.value.splice(index, 1);
};

// 选择物料
const handleMaterielSelect = () => {
  if (!formData.value.warehouseId) return ElMessage.warning("请先选择入库仓库");
  const ids = [];
  tableData.value.forEach((item) => {
    ids.push(item.materialId);
  });
  selectRef.value?.handleDialogOpen(ids);
};

// 物料选择结束回调
const materielSelectDone = (val) => {
  val.map((i) => {
    i.materialName = i.name;
    i.materialId = i.id;
  });
  // 创建一个Set用来存储val数组中的number
  let numbersInTable = new Set(tableData.value.map((item) => item.number));

  // 遍历val数组，将不在table数组中的对象加入table数组
  val.forEach((item) => {
    if (!numbersInTable.has(item.number)) {
      item.id = "";
      tableData.value.push(item);
      numbersInTable.add(item.number);
    }
  });

  // tableData.value = tableData.value.concat(val);
};

// 选择供应商
const handleSupplierSelect = (index) => {
  selectIndex.value = index;
  supplierSelectRef.value?.handleDialogOpen();
};

const handleSupplierChange = () => {
  supplierSelectRef.value?.handleDialogOpen();
};

// 选择项目
const handleProjectSelect = () => {
  projectSelectRef.value?.handleDialogOpen();
};

// 供应商选择结束回调
const supplierSelectionDone = (val) => {
  formData.value.supplierName = val.name;
  formData.value.supplier = val.id;
  // 表格里面隐藏了这项
  // tableData.value[selectIndex.value].supplierName = val.name;
  // tableData.value[selectIndex.value].supplier = val.id;
};

// 项目选择结束回调
const ProjectSelectionDone = (val) => {
  formData.value.thirdResourceId = val.id;
  formData.value.thirdResourceName = val.name;
  formData.value.thirdResourceRef = val.ref;
  formData.value.thirdResourceType = "ENGINEERING_PROJECT";
};

// 新增入库
const addBound = (req) => {
  insertBoundIn(req)
    .then((res) => {
      if (res.code == "2000") {
        ElMessage.success("操作成功");
        emits("afterSave");
        visible.value = false;
      }
    })
    .catch((err) => {
      buttonLoading.value = false;
    });
};

// 编辑入库
const editBound = (req) => {
  editBoundApi(req)
    .then((res) => {
      if (res.code == "2000") {
        ElMessage.success("操作成功");
        emits("afterSave");
        visible.value = false;
      }
    })
    .catch((err) => {
      buttonLoading.value = false;
    });
};

// 获取入库类型列表
const getTypeList = () => {
  queryDictList(DICT_KEY["boundTypeIn"]).then((res) => {
    typeList.value = res.data || [];
  });
};

//入库类型变化
const changeType = (val) => {
  formData.value.thirdResourceName = null;
  formData.value.thirdResourceRef = null;
  formData.value.thirdResourceId = null;
  formData.value.thirdResourceType = null;
};

// 获取库位列表
const getLocationList = (id) => {
  queryStashById(id).then((res) => {
    locationList.value = res.data.warehousePositionList || [];
  });
};

// 仓库变化
const warehouseChanged = (val) => {
  tableData.value = [];
  locationList.value = [];
  if (val) getLocationList(val);
};

//  文件预览
const previewImg = (fields, target) => {
  let result;
  if (!fields) return (target.value = null);
  axios
    .post(
      "/api/storeroom/file/preview",
      {
        reduceUrl: fields,
      },
      { responseType: "arraybuffer" }
    )
    .then((res) => {
      let url = "";
      const bytes = new Uint8Array(res.data);
      let len = bytes.length;
      for (let i = 0; i < len; i++) {
        url += String.fromCharCode(bytes[i]);
      }
      result = "data:image/jpg;base64," + window.btoa(url);
    })
    .finally(() => {
      target.value = result;
      console.log(result);
    });
};

const fileSelected = (val) => {
  if (val) {
    uploadSign(val.raw, val.name, "annex", true);
  } else {
    formData.value.annex = "";
  }
};

// 点击文件下载
const fileDownload = (file) => {
  console.log(file);
  postDownload(
    "/atom/file/download",
    {
      downloadUrl: file.reduceUrl,
    },
    file.name
  );
};

// 获取供应商列表
const getSupplierList = () => {
  querySupplierList({
    page: 1,
    limit: 9999,
    status: "1",
  }).then((res) => {
    supplierList.value = res.data.records;
  });
};

// 获取工程类型列表
const projectList = ref([]);
const getProjectList = () => {
  queryDictList(DICT_KEY["storeroom_project_type"]).then((res) => {
    projectList.value = res.data || [];
  });
};

watch(
  () => tableData.value,
  (newVal) => {
    newVal.forEach((row) => {
      if (row.totalWarehousePrice && row.changeQuantity) {
        row.price = (row.totalWarehousePrice / row.changeQuantity).toFixed(2);
      }
    });
  },
  { deep: true }
);

// 暴露函数给父组件
defineExpose({
  handleDialogOpen,
});
</script>

<style scoped>
.flex {
  display: flex;
  justify-content: space-between;
}

.mt10 {
  margin-top: 5px;
}
.flex-center {
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  border: 1px solid #ccc;
}
.my_class {
  max-width: 100%;
  word-break: break-all;
  word-wrap: break-word;
}
</style>
